module.exports = new __parcel__URL__("binance.e8e8711e.png").toString();